const ScheduleCard = ({ schedule }) => {
  return (
    <div className="schedulecard">
      <h2 className="schedulecard__heading">{schedule.heading}</h2>


      <div className="schedulecard__table">

        <div className="schedulecard__table--row schedulecard__table--row-heading">
          <span>Time</span>
          <span>Event</span>
        </div>

        {
          schedule.events.map(event => <div className="schedulecard__table--row"><span>{event.time}</span><span>{event.name}</span></div>)
        }


      </div>
    </div>

  )
}

export default ScheduleCard;